import { render, staticRenderFns } from "./ThreatFlowsTable.vue?vue&type=template&id=67790ebb&"
import script from "./ThreatFlowsTable.vue?vue&type=script&lang=js&"
export * from "./ThreatFlowsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports